"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LegacyRedirect = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const LegacyRedirect = _ref => {
  let {
    authnResponse
  } = _ref;
  const formRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    formRef.current.submit();
  }, []);
  return /*#__PURE__*/_react.default.createElement("form", {
    ref: formRef,
    method: "post",
    action: authnResponse.providerUrl
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "RelayState",
    value: authnResponse.relayState
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: authnResponse.assertionParameterName,
    value: authnResponse.assertion
  }));
};
exports.LegacyRedirect = LegacyRedirect;
var _default = exports.default = LegacyRedirect;
LegacyRedirect.propTypes = {
  authnResponse: _propTypes.default.shape({
    providerUrl: _propTypes.default.string.isRequired,
    relayState: _propTypes.default.string,
    assertionParameterName: _propTypes.default.string.isRequired,
    assertion: _propTypes.default.string.isRequired
  })
};
//# sourceMappingURL=LegacyRedirect.js.map